module.exports = __webpack_public_path__ + "static/media/booking.2f0a3e13.png";